import { render } from "./dashboard_knowledgehub.html?vue&type=template&id=3fea11be&external"
import script from "./dashboard_knowledgehub.js?vue&type=script&lang=js&external"
export * from "./dashboard_knowledgehub.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__